module.exports = __webpack_public_path__ + "img/bus.6b78c3dc.png";